module.exports = __webpack_public_path__ + "img/259-bb1932.png";